import { render, staticRenderFns } from "./empresa.vue?vue&type=template&id=45e922a2&scoped=true&"
import script from "./empresa.vue?vue&type=script&lang=js&"
export * from "./empresa.vue?vue&type=script&lang=js&"
import style0 from "./empresa.vue?vue&type=style&index=0&id=45e922a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e922a2",
  null
  
)

export default component.exports